import React from 'react';
import Modal from '../Modal';
import {useTranslation} from 'react-i18next';

const THEMES = {
    danger: {
        headerGradient: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
        accentRgb: '231, 76, 60',
        softColor: '#ff8888',
        defaultIcon: 'fas fa-exclamation-triangle',
    },
    warning: {
        headerGradient: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
        accentRgb: '242, 146, 5',
        softColor: '#ffc266',
        defaultIcon: 'fas fa-exclamation-triangle',
    },
};

/**
 * Confirmação no Modal da aplicação (mesmo padrão da listagem /trading ao excluir).
 * variant="warning" para ações como importação CSV (tom laranja do app).
 */
export default function ConfirmDeleteModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    notice,
    loading = false,
    variant = 'danger',
    confirmLabel,
    cancelLabel,
    headerIconClass,
    showNotice = true,
}) {
    const { t } = useTranslation();

    const tone = THEMES[variant] || THEMES.danger;
    const { headerGradient, accentRgb, softColor, defaultIcon } = tone;
    const iconClass = headerIconClass || defaultIcon;

    const noticeText = notice != null ? notice : t('delete_confirm_modal_notice');

    const headerTitle = (
        <div
            style={{
                background: headerGradient,
                margin: 0,
                padding: '26px 24px 24px 24px',
                borderRadius: '14px 14px 0 0',
                borderBottom: '2px solid rgba(255, 255, 255, 0.1)',
            }}
        >
            <h2
                style={{
                    margin: 0,
                    color: '#ffffff',
                    fontSize: '22px',
                    fontWeight: 700,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                }}
            >
                <i className={iconClass} style={{ fontSize: '22px' }} aria-hidden="true"/>
                {title}
            </h2>
        </div>
    );

    const cancelText = cancelLabel != null ? cancelLabel : t('alert_cancel');
    const confirmText = confirmLabel != null ? confirmLabel : t('alert_confirm');

    const footer = (
        <>
            <button
                type="button"
                disabled={loading}
                onClick={onClose}
                style={{
                    background: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    color: '#b0b0b0',
                    padding: '10px 24px',
                    borderRadius: '999px',
                    fontWeight: 600,
                    fontSize: '14px',
                    cursor: loading ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease',
                    opacity: loading ? 0.6 : 1,
                }}
                onMouseEnter={(e) => {
                    if (!loading) {
                        e.target.style.background = 'rgba(255, 255, 255, 0.12)';
                        e.target.style.color = '#e0e0e0';
                    }
                }}
                onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.08)';
                    e.target.style.color = '#b0b0b0';
                }}
            >
                {cancelText}
            </button>
            <button
                type="button"
                disabled={loading}
                onClick={onConfirm}
                style={{
                    background: headerGradient,
                    border: 'none',
                    color: '#ffffff',
                    padding: '10px 24px',
                    borderRadius: '999px',
                    fontWeight: 600,
                    fontSize: '14px',
                    cursor: loading ? 'wait' : 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: `0 4px 15px rgba(${accentRgb}, 0.35)`,
                    opacity: loading ? 0.85 : 1,
                }}
                onMouseEnter={(e) => {
                    if (!loading) {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = `0 6px 20px rgba(${accentRgb}, 0.45)`;
                    }
                }}
                onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = `0 4px 15px rgba(${accentRgb}, 0.35)`;
                }}
            >
                {loading ? t('loading') : confirmText}
            </button>
        </>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={loading ? () => {} : onClose}
            title={headerTitle}
            footer={footer}
            narrow
        >
            <p
                style={{
                    margin: showNotice ? '0 0 20px 0' : '0',
                    color: '#b0b0b0',
                    fontSize: '15px',
                    lineHeight: 1.6,
                }}
            >
                {message}
            </p>
            {showNotice ? (
                <div
                    style={{
                        background: `rgba(${accentRgb}, 0.14)`,
                        borderRadius: '10px',
                        padding: '16px',
                        border: `1px solid rgba(${accentRgb}, 0.35)`,
                    }}
                >
                    <p
                        style={{
                            margin: 0,
                            color: softColor,
                            fontSize: '14px',
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: '10px',
                            fontWeight: 500,
                            lineHeight: 1.45,
                        }}
                    >
                        <i className="fas fa-info-circle" style={{ marginTop: '2px' }} aria-hidden="true"/>
                        {noticeText}
                    </p>
                </div>
            ) : null}
        </Modal>
    );
}
